import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const consumerGroupsApiUrl = `${apiUrl}consumerGroups`;


export const consumerGroupsGet = (includeInactive) =>
    axios.get(`${consumerGroupsApiUrl}?includeInactive=${includeInactive}`);

export const consumerGroupsGetById = (groupId) =>
    axios.get(`${consumerGroupsApiUrl}/${groupId}`);

export const consumerGroupInsert = (data) =>
    axios.post(`${consumerGroupsApiUrl}`, data);

export const consumerGroupUpdate = (id, data) =>
    axios.put(`${consumerGroupsApiUrl}/${id}`, data);

export const consumerGroupDelete = (id) =>
    axios.delete(`${consumerGroupsApiUrl}/${id}`);
